import React from 'react'

import { useTranslation } from 'language/translator'

import Icon from 'components_new/atoms/Icon'
import ListItemButton from 'components_new/atoms/List/ListItemButton'
import ListItemIcon from 'components_new/atoms/List/ListItemIcon'
import ListItemText from 'components_new/atoms/List/ListItemText'
import Switch from 'components_new/atoms/Switch'

import FormSection from 'components_new/molecules/FormSection'

interface VisibilityProps {
  onSubmit: (value: boolean) => void
  value: boolean
}

const Visibility = (props: VisibilityProps) => {
  const { onSubmit, value } = props

  const { t } = useTranslation()

  return (
    <FormSection
      helperText={t('groups', 'visibility_helper_text')}
      importance="optional"
      size="small"
      title={t('groups', 'visibility_title')}
    >
      <ListItemButton
        onClick={() => onSubmit(!value)}
        sx={{ bgcolor: 'background.default' }}
      >
        <ListItemIcon>
          <Icon name={'VisibilityOutlined'} />
        </ListItemIcon>
        <ListItemText
          primary={t('groups', 'show_on_home_title')}
          secondary={t('groups', 'show_on_home_helper_text')}
          secondaryTypographyProps={{ color: 'text.secondary' }}
        />
        <Switch
          checked={value}
          onChange={() => onSubmit(!value)}
          value={value}
        />
      </ListItemButton>
    </FormSection>
  )
}

export default Visibility
